import { render, staticRenderFns } from "./AuthLayoutV2.vue?vue&type=template&id=1508273a&scoped=true&"
import script from "./AuthLayoutV2.vue?vue&type=script&lang=js&"
export * from "./AuthLayoutV2.vue?vue&type=script&lang=js&"
import style0 from "./AuthLayoutV2.vue?vue&type=style&index=0&id=1508273a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1508273a",
  null
  
)

export default component.exports